import React from 'react';
import { Button } from '@thd-olt-component-react/core-ui';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { format } from 'react-phone-input-auto-format';
import PropTypes from 'prop-types';
import { Chat } from '@one-thd/sui-icons';
import { clickEvents } from '../../../../utils/analytics';
import { sendSmsToCandidate } from '../../../../utils/sendSmsToCandidate';
import './ContactButtons.scss';

const TextMeButton = ({ phoneNumber, candidateId, textOptIn }) => {

  if (!textOptIn) {
    return null;
  }

  const handleClick = async () => {
    try {
      clickEvents.candidatePageInteraction('contact', 'text', candidateId);
      await sendSmsToCandidate(phoneNumber, candidateId);
    } catch (error) {
      console.error('Failed to send SMS to candidate', error);
    }
  };

  if (!phoneNumber) {
    return (
      <div className="contact-button">
        <Button disabled>
          <span className="contact-button__icon">
            <Chat size="small" />
          </span>
          <span className="contact-button__label">
            Text
          </span>
        </Button>
      </div>
    );
  }

  return (
    <div className="contact-button">
      <Tooltip
        channel="desktop"
        closeButton
        content={(
          <div className="contact-button__tooltip" data-testid="text-me-btn-tooltip">
            {format(phoneNumber || '')}
          </div>
        )}
        showClose={false}
      >
        <div
          onClick={handleClick}
          className="contact-button__btn secondary"
        >
          <span className="contact-button__icon">
            <Chat style={{ fontSize: '32px' }} />
          </span>
          <span className="contact-button__label">
            Text
          </span>
        </div>
      </Tooltip>
    </div>
  );
};

TextMeButton.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  candidateId: PropTypes.number.isRequired,
  textOptIn: PropTypes.bool.isRequired
};

export default TextMeButton;
